import { ICheckboxProps } from "@fluentui/react";
import React, { useState } from "react";
import { Control, Controller, ControllerRenderProps } from "react-hook-form";

import { Checkbox } from "../inputs/checkbox/Checkbox";

export interface FormCheckboxProps extends ICheckboxProps {
    label: string;
    name: string;
    control: Control;
    check?: boolean;
}

export const FormCheckbox: React.VFC<FormCheckboxProps> = ({
    label,
    name,
    control,
    check,
    styles
}: FormCheckboxProps) => {
    const [isChecked, setIsChecked] = useState<boolean>(check ?? false);

    const render = (prop: ControllerRenderProps<Record<string, unknown>>) => {
        const handleCheckboxValueChange = (
            _ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
            checked?: boolean
        ) => {
            setIsChecked(!!checked);
            prop.onChange(!!checked);
        };
        return (
            <Checkbox
                label={label}
                onChange={handleCheckboxValueChange}
                checked={prop.value || isChecked}
                testId={name}
                styles={styles}
            />
        );
    };

    return <Controller name={name} control={control} render={render} />;
};
